<template>
  <v-container pa-0 grid-list-xl class="placeholder">
    <v-layout row wrap>
      <v-flex xs12 lg6 xl4 v-for="item in count" :key="item">
        <div class="placeholder-item"></div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "placeholder",

  computed: {
    count() {
      if (this.$vuetify.breakpoint.xsOnly) return 1;
      if (this.$vuetify.breakpoint.lgAndDown) return 2;
      return 3;
    }
  }
};
</script>

<style lang="scss" scoped>
.placeholder {
  &-item {
    height: 300px;
    width: 100%;
    background-color: var(--v-secondary-base);
    position: relative;

    &::after {
      content: "";
      display: block;
      position: absolute;
      width: 100%;
      height: 50px;
      bottom: 0;
      background-color: white;
    }
  }
}

@keyframes progress {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}
</style>
